import React from 'react';
import { useTranslation } from 'react-i18next';
import imgTarjetaEroskiPromocion from '../../../assets/images/tarjeta-eroski-cupon.png';
import imgTarjetaCapraboPromocion from '../../../assets/images/tarjeta-caprabo-promocion-moneda2.png';

const CuponPromocion = ({
  dataApp,
  unidad,
  oferta,
  data,
  isEroski,
  showCondLegales,
  setPromocion,
}) => {
  const { t } = useTranslation();

  const descuentoUnidad =
    dataApp.lang === 'eu' && unidad === '%' ? (
      <>
        <sup>{unidad}</sup>
        {oferta}
      </>
    ) : (
      <>
        {oferta}
        <sup>{unidad}</sup>
      </>
    );

  const txtFechaFinDescuento =
    dataApp.lang === 'eu'
      ? t('vales.promocion.fecha-validez', {
          fechafin: data.fechaFinCanjeoPromo,
        })
      : t('vales.promocion.fecha-validez').concat(data.fechaFinCanjeoPromo);

  const txtDesc2 = data.textoDescripcion2 != null ? data.textoDescripcion2 : '';

  const condicionesPromocion =
    data.textoDescripcion1 != null
      ? data.textoDescripcion1.concat(txtDesc2)
      : txtDesc2;

  const imgTarjeta = isEroski
    ? imgTarjetaEroskiPromocion
    : imgTarjetaCapraboPromocion;

  const txtAltTarjeta = isEroski
    ? 'imagen de la tarjeta Eroski'
    : 'imagen de la tarjeta Caprabo';

  return (
    <>
      <h3 className="promocion__title u-text-brand">
        {descuentoUnidad}
        {t('vales.promocion.descuento')}
      </h3>
      <p className="promocion__subtitle">{data.textoTitulo}</p>
      <div className="promocion__body">
        <p>{condicionesPromocion}</p>
      </div>
      <div className="promocion__footer">
        <img src={imgTarjeta} alt={txtAltTarjeta} />
        <p>{txtFechaFinDescuento}</p>
      </div>
      <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
        <a
          href="#legal-conditions"
          className="legal-conditions icon-link u-align-items-baseline"
          rel="noopener noreferrer"
          onClick={() => {
            setPromocion(true);
            showCondLegales(true);
          }}
        >
          <span className="u-font-medium">
            {isEroski
              ? t('vales.condiciones-legales-titulo')
              : t('caprabo.cupones.condiciones-legales-titulo')}
          </span>
        </a>
      </div>
    </>
  );
};

export default CuponPromocion;
